export default __webpack_public_path__ + "static/media/link_black.1c528f21.svg";